import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import type { ProductSpecs } from "../../services/apiService";

const formatValue = (value: unknown): string => {
  if (Array.isArray(value)) return value.join(", ");
  return String(value);
};

const SpecsTable: React.FC<{ specs: ProductSpecs }> = ({ specs }) => (
  <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: "16px" }}>
    <Table size="small" aria-label="Product specifications">
      <TableBody>
        {Object.entries(specs).map(([key, value], i) => (
          <TableRow
            key={key}
            sx={{ bgcolor: i % 2 === 0 ? "background.default" : "background.paper" }}
          >
            <TableCell
              component="th"
              scope="row"
              sx={{ fontWeight: 700, width: { xs: "42%", md: "32%" }, verticalAlign: "top" }}
            >
              {key}
            </TableCell>
            <TableCell>{formatValue(value)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default SpecsTable;
